export default String.raw`
.check-availability {
    max-width: 768px;
    width: 768px;
    max-height: 492px;

    &:has(.availability__details[open]) {
        max-height: 748px;
    }

    .dialog {
        &__content {
            padding: 24px 32px 32px 32px;
            gap: 16px;

            .check-availability__form {
                width: 258px;
            }
        }

        &__actions {
            padding: 0 0 32px 0;
            gap: 24px;
            width: 100%;
            justify-content: center;
        }
    }

    &__list {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        align-self: stretch;
        overflow: auto;

        &-item {
            display: flex;
            width: 100%;
            border-top: 1px solid #E7E7E7;
        }
    }

    .availability {
        &__details {
            display: flex;
            padding: 16px 0px;
            width: 100%;
            flex-direction: column;

            &-section {
                display: flex;
                align-items: center;
                gap: 24px;
            
                &:first-child {
                    margin-bottom: 24px;
                }

                .details-section__hours .line:only-child {
                    display: none;
                }

                .details-section__contact .line:only-child {
                    display: none;
                }
            
                .line {
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: 20px; /* 142.857% */
                    margin-bottom: 8px;
                }
            
                .line-title {
                    font-size: 14px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 20px; /* 142.857% */
                    margin-bottom: 16px;
                }
            
                .link {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    gap: 8px;
                    font-size: 12px;
                    font-style: normal;
                    font-weight: 500;
                    line-height: 16px;
                    color: #2e2e2e;
                }
                
                .link.line {
                    margin-bottom: 12px;
                }
            
                > * {
                    flex: 1 1 auto;
                }
            }

            .availability__status-value {
                span {
                    font-weight: 500;
                }

                &--word[data-value="0"] {
                    color: #DA2442;
                }
                &--word:not([data-value="0"]) {
                    color: #008945;
                }
            }

            &[open] {
                > *:not(:last-child) {
                    margin-bottom: 24px;
                }

                .availability {
                    &__summary {
                        gap: 0;

                        svg {
                            transform: rotate(180deg);                
                        }
                    }

                    &__status {
                        flex: 1 1 auto;
                        gap: 0;
                        justify-content: space-between;
                    }
                }
            }
        }

        &__status {
            display: flex;
            gap: 24px;
        }

        &__shop {
            font-size: 14px;
            font-style: normal;
            font-weight: 500;
            line-height: 20px; /* 142.857% */
            flex: 1 1 auto;
        }

        &__summary {
            list-style: none;
            flex-direction: row;
            display: flex;
            cursor: pointer;
            align-items: center;
            gap: 24px;
            align-self: stretch;
            justify-content: space-between;
        }
    }
}
`